import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import {
  AutoCompleteProps,
  AutoComplete
} from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { useStore } from "../../../models";
import { IRole } from "../../../models/role/Role";
import settingsStyles from "../../../styles/settings.css";

interface Props extends Omit<Partial<AutoCompleteProps<IRole>>, "onChange"> {
  onChange(role: IRole): void;
  roleId?: string;
  /** Set roles suggested in autocomplete, if ommited will default to roles from RoleStore */
  values?: IRole[];
}

export const RolePicker = observer(
  ({ onChange, values, className, roleId, ...autoCompleteProps }: Props) => {
    const { roleStore } = useStore();
    const roles: IRole[] = values || roleStore.rolesArray;
    const value = roleId ? roleStore.getRoleById(roleId) : undefined;

    const handleChange = (val: IRole | "") => {
      if (val) {
        onChange(val);
      }
    };

    return (
      <AutoComplete<IRole>
        {...autoCompleteProps}
        className={classNames(settingsStyles["input-max-width-bigger"], className)}
        onChange={handleChange}
        itemsProvider={() => roles}
        itemToString={(val) => val?.name || ""}
        placeholder={intl.formatMessage("rolePicker.placeholder")}
        readOnly
        inputValue={value?.name}
        emptyPlaceholder={intl.formatMessage("rolePicker.empty")}
      />
    );
  }
);
